import { useLanguage } from "../i18n/LanguageContext";

export default function Footer() {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();
  const supportHref = lang === "en" ? "/en/support" : "/support";

  return (
    <footer data-testid="site-footer" className="bg-navy text-[#F7F5F0] py-20 md:py-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-y-10 md:gap-x-10">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-8">
              <img
                src="/brand/ghio-logo-op-donker.svg"
                alt="Ghio"
                width="135"
                height="40"
                loading="lazy"
                decoding="async"
                className="h-10 w-auto"
                data-testid="footer-logo"
              />
            </div>
            <p className="heading-display text-3xl md:text-5xl max-w-xl leading-[1.1]">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="eyebrow text-green mb-4">{t("footer.office")}</div>
            <p className="text-sm leading-relaxed text-white/80">
              Houtsaachmole 3C
              <br />
              8531 WC Lemmer
              <br />
              Nederland
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="eyebrow text-green mb-4">{t("footer.contact")}</div>
            <ul className="text-sm space-y-1 text-white/80">
              <li>
                <a href="mailto:info@ghio.nl" className="inline-flex items-center min-h-[44px] py-2 hover:text-white">
                  info@ghio.nl
                </a>
              </li>
              <li>
                <a href="tel:+31653731819" className="inline-flex items-center min-h-[44px] py-2 hover:text-white">
                  +31 6 53 73 18 19
                </a>
              </li>
              <li>
                <a
                  href={supportHref}
                  data-testid="footer-support-link"
                  className="inline-flex items-center min-h-[44px] py-2 hover:text-white underline-offset-4 hover:underline"
                >
                  {t("nav.support")} →
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <div className="eyebrow text-green mb-4">{t("footer.legal")}</div>
            <p className="text-sm text-white/80">{t("footer.kvk")}</p>
            <a
              href="/manage"
              data-testid="footer-portal-link"
              className="block mt-4 text-sm text-white/80 underline-offset-4 hover:underline hover:text-white"
            >
              Klantportaal →
            </a>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <span>
            © {year} Ghio Webservices. {t("footer.rights")}
          </span>
          <a
            href="https://ghio.nl"
            target="_blank"
            rel="noopener"
            data-testid="footer-signature"
            className="tracking-wider hover:text-white/80 transition-colors"
          >
            {lang === "en" ? "Designed with calm and " : "Ontworpen met rust en "}
            <span role="img" aria-label={lang === "en" ? "love" : "liefde"} className="text-green">♥</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
